import styled from 'styled-components';

export const Title = styled.h2`
  display: block;
  color: ${(p) => p.theme.accent.secondary};
  font-size: 1.25rem;
  margin-top: -0.5rem;
  text-transform: uppercase;

  :before {
    content: '>';
    color: ${(p) => p.theme.accent.primary}99;
    margin-right: 10px;
    font-size: 1.2rem;
    display: inline;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
    margin-top: -0.2rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px 50px;
  margin-top: 1.4rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px 24px;
    margin-top: 0.8rem;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemLogo = styled.div`
  font-size: 1.6rem;
  color: ${(p) => p.theme.accent.primary};
  margin-right: 10px;

  @media screen and (max-width: 768px) {
    font-size: 1.3rem;
  }
`;
